export default "__VITE_ASSET__BB88VVxB__"